import { logEvent } from '../../lib/analytics';

interface AgentsMobileSchedulingProps {
  numTimeSlotsToday: number;
  numTimeSlotsTomorrow: number;
  setCalendlyModalUri: (calendlyUri: string) => void;
  calendlyUri: string;
  calendlyUriFullCalendar: string | undefined;
  today: string;
  tomorrow: string;
}

export const AgentsMobileScheduling: React.FC<AgentsMobileSchedulingProps> = ({
  numTimeSlotsToday,
  numTimeSlotsTomorrow,
  setCalendlyModalUri,
  calendlyUri,
  calendlyUriFullCalendar,
  today,
  tomorrow,
}) => (
  <div className="sm:hidden border-b pb-4">
    {numTimeSlotsToday ? (
      <button
        className="bg-blue-500 text-white rounded-md hover:bg-blue-400 p-3 w-full mt-6"
        onClick={() => {
          setCalendlyModalUri(`${calendlyUri}?date=${today}`);
          logEvent({
            category: 'Agent Directory',
            name: 'Open today button clicked',
            calendlyUri,
          });
        }}
      >
        {numTimeSlotsToday} Open Today
      </button>
    ) : null}
    {!numTimeSlotsToday && numTimeSlotsTomorrow ? (
      <button
        className="bg-blue-500 text-white rounded-md hover:bg-blue-400 p-3 w-full mt-6"
        onClick={() => {
          setCalendlyModalUri(`${calendlyUri}?date=${tomorrow}`);
          logEvent({
            category: 'Agent Directory',
            name: 'Open tomorrow button clicked',
            calendlyUri,
          });
        }}
      >
        {numTimeSlotsTomorrow} Open Tomorrow
      </button>
    ) : null}
    <button
      className="border rounded-md hover:bg-gray-100 p-3 w-full mt-4"
      onClick={() => {
        setCalendlyModalUri(calendlyUriFullCalendar ?? calendlyUri);
        logEvent({
          category: 'Agent Directory',
          name: 'See full calendar button clicked',
          calendlyUri,
        });
      }}
    >
      See Full Calendar
    </button>
  </div>
);
